import { Component, OnInit,ViewChild,ElementRef,Renderer2,ViewChildren,QueryList, Output, EventEmitter, Input } from '@angular/core';
import { ColDef, GridApi, ColumnApi } from 'ag-grid-community';
import { CommonGridService } from '../services/common-grid.service';
import {RowModelType,GridReadyEvent,IDatasource,IGetRowsParams,SortModelItem} from '@ag-grid-community/core';
import { SidePanelService } from '../services/side-pannel/side-pannel.service';
import { MatSelect} from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { HomeService } from '../services/home.service';
import { NotifierService } from 'angular-notifier';
import { MatDialog } from '@angular/material/dialog';
import { CallRecordingModalComponent } from 'src/app/repository/call-recording-modal/call-recording-modal.component';

@Component({
  selector: 'app-common-grid-view',
  templateUrl: './common-grid-view.component.html',
  styleUrls: ['./common-grid-view.component.scss']
})
export class CommonGridViewComponent implements OnInit {
  @ViewChild('selectCtrl') selectCtrl: MatSelect;
  @ViewChildren(MatOption) matOptions: QueryList<MatOption>;
  @Output() onScrollEvent = new EventEmitter<any>();
  @Output() onApplyFilterEvent = new EventEmitter<any>();
  @Output() onGridSorting = new EventEmitter<any>();
  @Output() onSearchChangeEvent = new EventEmitter<any>();
  @Output() onDownloadEvent= new EventEmitter();
  @Input() isAutoGrid:boolean=false;
  @Input() isFilterShow:boolean = false;
  @Input() isDownloadShow:boolean = false;
  @Input() isSearchShow:boolean = false;
  @Input() checkGridDataLoaded:boolean = false;
  @Input() showTotalDataCount:boolean=false;
  @Input() apiUrl:string = "";
  @Input() breadcrumbName:string = ""
  @Input() type:string = "";
  @Input() inputBody:any = {};
  

  public gridItem:{};
  public cityFilter:any = [];
  public dayFilter:any = [];
  public countFilter:any = [];

  public isLoading:boolean = false;
  public showSearchBar:boolean = false;
  public isDashBoardDayWise:boolean;
  public scrollDistance = 1;
  public throttle = 10;
  public searchText:string = ""
  public commonGridPlaceHolder = "Search Here....";
  public rowModelType: RowModelType = 'infinite';
  public maxConcurrentDatasourceRequests = 2;
  public infiniteInitialRowCount = 2;
  public bufferInterval;
  private gridApi!: GridApi;
  private gridColumnApi: ColumnApi;
  public defaultColDef: ColDef = {
    editable: true,
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    minWidth: 100,
    enableRowGroup: true,
    enablePivot: true,
    enableValue: true
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';

  constructor(
    public cgService:CommonGridService,
    private sidePanelService:SidePanelService,
    public render:Renderer2,
    public homeService:HomeService,
    public notify:NotifierService,
    public dialog:MatDialog
  )
 { }

  ngOnInit(): void {
    // if(localStorage.getItem('studyId')){
    //   this.cgService.studyId = localStorage.getItem('studyId');
    //   if(this.cgService.studyId === 'a566179a-e9bd-4810-bbc2-29fc89f9f856' || this.cgService.studyId === '068e0008-8bf3-4cd4-8cc4-59b78432dc63'){
    //     this.cgService.surveyId = 13776;
    //   }else{
    //     this.cgService.surveyId = 12703;
    //   }
    // }
    // this.cgService.resetAll();
    // this.cgService.isLoading = true;
    const url = window.location.href;    
    this.isAutoGrid;
    this.apiUrl;
    if (this.isAutoGrid) {
      this.initAutoGridData();
      this.bufferInterval = setInterval(() =>{
        if (!this.cgService.isLoading ) {
          this.getBufferDataForAutoGrid();
          clearInterval(this.bufferInterval);
        }
      },100)
      //  setTimeout(() =>{
      //     this.getBufferDataForAutoGrid();
      //   },1000)
    }


    // if(url.includes('/home/dairy-dashboard/day-wise')){
    //   this.isDashBoardDayWise = true;
    //   this.getDairyDashboardDataDayWise();
    // }else{
    //   this.isDashBoardDayWise = false;
    //   this.getDairyDashboardDataCenterWise();
    // }
    // setTimeout(() =>{
    //   this.getBufferDataForDairy();
    // },1000)
  }

  getBufferDataForAutoGrid(isScroll?){
    if(!isScroll){
      this.cgService.page++;
    }
    let body = {
      page:this.cgService.page,
      page_size:this.cgService.page_size,
      type:(this.type && this.type !="") ? this.type:'',
      survey_id:this.cgService.surveyId
    };
     if(this.inputBody){
      Object.keys(this.inputBody).forEach(key =>{
        body[key] = this.inputBody[key];
      })
    }
    let page = this.cgService.page;
    if(page <= this.cgService.gridPageTotal){
      this.gridApiRequest(body,false,true);
    }
  }

  initAutoGridData(){
    this.cgService.resetAll();
    this.cgService.showTotalDataCount = this.showTotalDataCount ? true : false;
    let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId};
    if (this.type && this.type !='') {
      body['type'] = this.type
    }
    if(this.inputBody){
      Object.keys(this.inputBody).forEach(key =>{
        body[key] = this.inputBody[key];
      })
    }
    this.cgService.getAutoGridData(body,this.apiUrl,true);
  }

   gridApiRequest(body,isDownload?,isbuffer?){
    if(this.cgService.sortby != ''){
      body['sortby'] = this.cgService.sortby;
      body['order'] = this.cgService.sortOrder;
    }
    if(this.cgService.serachBy && this.cgService.serachBy.length > 2){
      body['searchBy'] = this.cgService.serachBy;
    }
    if(this.checkForFilter()){
      body['filters'] = this.cgService.appliedFilter;
    }
    if (this.type && this.type !='') {
      body['type'] = this.type
    }
    if(isDownload){
      let fileName = (this.type && this.type !='') ? this.type+'-Grid-Data':'Grid-Data'
      this.cgService.jsonToCsvDownload(body,fileName);
    }else{
      this.cgService.getAutoGridData(body,this.apiUrl,false,isbuffer);
    }
  }

    checkForFilter(){
    if(Object.keys(this.cgService.appliedFilter).length){
      let isDateValid = true;
      Object.keys(this.cgService.appliedFilter).forEach(key =>{
        if(!this.cgService.appliedFilter[key].length){
          delete this.cgService.appliedFilter[key];
        }
        if(key === 'date'){
          if(this.cgService.appliedFilter[key]){
            this.cgService.appliedFilter[key].forEach(va =>{
              if(!va){
                this.notify.notify('error','Please Select Start or End Date');
                isDateValid = false;
                return;
              }
            })
          }
        }
      })
      return Object.keys(this.cgService.appliedFilter).length && isDateValid ? true : false;
    }else{
      return false;
    }
  }

  


  // getBufferDataForDairy(isScroll?){
  //   if(!isScroll){
  //     this.cgService.page++;
  //   }
  //   let body = {
  //     page:this.cgService.page,
  //     page_size:this.cgService.page_size,
  //     type:this.isDashBoardDayWise ? 'day':'center',
  //     survey_id:this.cgService.surveyId
  //   };
  //   let page = this.cgService.page;
  //   if(page <= this.cgService.gridPageTotal){
  //     this.gridApiRequest(body,false,true);
  //   }
  // }

  // getDairyDashboardDataCenterWise(){
  //   this.cgService.resetAll();
  //   let body = {page:this.cgService.page,page_size:this.cgService.page_size,type:'center',survey_id:this.cgService.surveyId};
  //   this.cgService.getDairyDashboardDataCenterWise(body,true);
  // }

  // getDairyDashboardDataDayWise(){
  //   this.cgService.resetAll();
  //   let body = {page:this.cgService.page,page_size:this.cgService.page_size,type:'day',survey_id:this.cgService.surveyId};
  //   this.cgService.getDairyDashboardDataDayWise(body,true);
  // }

  gridFilter(selectCtrl:MatSelect,compObj,item){
    if(item['value'] === 'all'){
      if(!this.cgService.appliedFilter[item['key']]){
        this.cgService.appliedFilter[item['key']] = [];
        this.cgService.copyappliedFilter[item['key']] = [];

      }
      let isExit = this.cgService.copyappliedFilter[item['key']].findIndex(v => v === item['value']);
      if(isExit >=0){
        this.cgService.appliedFilter[item['key']] = [];
        this.cgService.copyappliedFilter[item['key']] = [];
        selectCtrl.options.forEach(option => {
          option.deselect();
        });
      }else{
        Object.keys(compObj).forEach(key =>{
          this.cgService.copyappliedFilter[item['key']].push(compObj[key]['value']);
          if(compObj[key]['value'] != 'all'){
            this.cgService.appliedFilter[item['key']].push(compObj[key]['value']);
          }
        })
        selectCtrl.options.forEach(option => {
          if(this.cgService.copyappliedFilter[item['key']].includes(option.value)){
            option.select();
          }
        });
      }
    }else{
      if(!this.cgService.appliedFilter[item['key']]){
        this.cgService.appliedFilter[item['key']] = [];
        this.cgService.copyappliedFilter[item['key']] = [];
      }
      let isExit = this.cgService.appliedFilter[item['key']].findIndex(v => v === item['value']);
      if(isExit >= 0){
        this.cgService.appliedFilter[item['key']].splice(isExit,1);
        let isAllExit = this.cgService.appliedFilter[item['key']].findIndex(v => v === 'all');
        if (isAllExit >= 0) {
          this.cgService.appliedFilter[item['key']].splice(isAllExit,1);
        }
        this.cgService.copyappliedFilter[item['key']] = this.cgService.appliedFilter[item['key']];
      }else{
        this.cgService.appliedFilter[item['key']].push(item['value']);
        this.cgService.copyappliedFilter[item['key']] = this.cgService.appliedFilter[item['key']];
      }
    }
  }

  onScroll(){
    if (this.isAutoGrid) {
      if(this.cgService.page <= this.cgService.gridPageTotal){
        this.cgService.gridDataContainer = [...this.cgService.gridDataContainer,...this.cgService.bufferArr];
        this.cgService.page++;
      }
      this.getBufferDataForAutoGrid(true);
    }else{
      this.onScrollEvent.emit({"scroll":true})
    }
  }

  // selectAll(filterKey) {
  //   this.cgService.gridFilters[filterKey]['isSelectAll'] = !this.cgService.gridFilters[filterKey]['isSelectAll'];
  //   if (this.cgService.gridFilters[filterKey]['isSelectAll']) {
  //     this.cgService.gridFilters[filterKey]['selectedItems'] = this.cgService.gridFilters[filterKey]['data']
  //     this.cgService.gridFilters[filterKey]['selectedItems'].push('all')
  //   }else{
  //     this.cgService.gridFilters[filterKey]['selectedItems'] = []
  //   }
  // }

  applyFilter(){
    if (this.isAutoGrid) {
      if(this.checkForFilter()){
        this.cgService.page = 1;
        this.cgService.page_size = 20;
        this.cgService.gridDataContainer = [];
        this.cgService.bufferArr = [];
        let body = {
          page:this.cgService.page,
          page_size:this.cgService.page_size,
          survey_id:this.cgService.surveyId,
          filters:this.cgService.appliedFilter,
        }
        if(this.cgService.sortby != ''){
          body['sortby'] = this.cgService.sortby;
        }
        if(this.cgService.serachBy && this.cgService.serachBy.length > 2){
          body['searchBy'] = this.cgService.serachBy;
        }
        if(this.type && this.type != ''){
          body['type'] = this.type;
        }
        body
        // debugger
        this.cgService.getAutoGridData(body,this.apiUrl);
        setTimeout(() =>{
          this.getBufferDataForAutoGrid();
        },1000)
      }
    }else{
      this.onApplyFilterEvent.emit({"filter":true})
    }
    // this.onApplyFilterEvent.emit({"filter":true})
  }

  // checkForFilter(){
  //   if(Object.keys(this.cgService.appliedFilter).length){
  //     let isDateValid = true;
  //     Object.keys(this.cgService.appliedFilter).forEach(key =>{
  //       if(!this.cgService.appliedFilter[key].length){
  //         delete this.cgService.appliedFilter[key];
  //       }
  //       if(key === 'date'){
  //         if(this.cgService.appliedFilter[key]){
  //           this.cgService.appliedFilter[key].forEach(va =>{
  //             if(!va){
  //               this.notify.notify('error','Please Select Start or End Date');
  //               isDateValid = false;
  //               return;
  //             }
  //           })
  //         }
  //       }
  //     })
  //     return Object.keys(this.cgService.appliedFilter).length && isDateValid ? true : false;
  //   }else{
  //     return false;
  //   }
  // }

  onSearchChange(value){
    if (this.isAutoGrid) {
      if(value.length > 2){
        this.cgService.serachBy = value
        this.cgService.gridDataContainer = [];
        this.cgService.bufferArr = [];
        this.cgService.page = 1;
        this.cgService.page_size = 20;
        let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId};
        this.gridApiRequest(body);
      }else{
        this.cgService.serachBy = value
        this.cgService.gridDataContainer = [];
        this.cgService.bufferArr = [];
        this.cgService.page = 1;
        this.cgService.page_size = 20;
        let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId};
        this.gridApiRequest(body);
      }
      setTimeout(() =>{
        this.getBufferDataForAutoGrid();
      },1000)
    }else{
      this.onSearchChangeEvent.emit({"str":value})
    }
    // this.onSearchChangeEvent.emit({"str":value})
  }

  getHeaderKeyLength(){
    return {
      'display':'grid',
      'grid-template-columns':'repeat('+Object.keys(this.cgService.gridHeaders).length + ',1fr)', 
    }
  }

  gridSorting(key,order){
    if (this.isAutoGrid) {
      if(!this.cgService.sortingDeatils[key]){
        this.cgService.sortingDeatils = {}
        this.cgService.sortingDeatils[key] = true;
      }else{
        this.cgService.sortingDeatils[key] = !this.cgService.sortingDeatils[key];
      }
      this.cgService.sortby = key;
      this.cgService.sortOrder = order;
      this.cgService.gridDataContainer = [];
      this.cgService.bufferArr = [];
      this.cgService.page = 1;
      this.cgService.page_size = 20;
      let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId,sortby:this.cgService.sortby,order:this.cgService.sortOrder};
      this.gridApiRequest(body);
      setTimeout(() =>{
        this.getBufferDataForAutoGrid();
      },1000)
    }else{
      this.onGridSorting.emit({"key":key,"order":order})
    }
    // this.onGridSorting.emit({"key":key,"order":order})
  }

  downloadGridData(){
    if (this.isAutoGrid) {
      let body = {survey_id:this.cgService.surveyId,no_pagination:true}
      this.gridApiRequest(body,true);
    }else{
      this.onDownloadEvent.emit()
    }
  }


  // gridApiRequest(body,isDownload?,isbuffer?){
  //   if(this.cgService.sortby != ''){
  //     body['sortby'] = this.cgService.sortby;
  //     body['order'] = this.cgService.sortOrder;
  //   }
  //   if(this.cgService.serachBy && this.cgService.serachBy.length > 2){
  //     body['searchBy'] = this.cgService.serachBy;
  //   }
  //   if(this.checkForFilter()){
  //     body['filters'] = this.cgService.appliedFilter;
  //   }
  //   if(this.isDashBoardDayWise){
  //     body['type'] = 'day';
  //     if(isDownload){
  //       this.cgService.jsonToCsvDownload(body,'Dairy-day');
  //     }else{
  //       this.cgService.getDairyDashboardDataDayWise(body,false,isbuffer);
  //     }
  //   }else{
  //     body['type'] = 'center';
  //     if(isDownload){
  //       this.cgService.jsonToCsvDownload(body,'Diary-Center');
  //     }else{
  //       this.cgService.getDairyDashboardDataCenterWise(body,false,isbuffer);
  //     }
  //   }
  // }

  changeDatePicker(key){
    if(!this.cgService.appliedFilter[key]){
      this.cgService.appliedFilter[key] = [];
    }
    this.cgService.appliedFilter[key][0] = this.cgService.startDate;
    this.cgService.appliedFilter[key][1] = this.cgService.endDate;
  }

  checkForSortingIcon(key){
    if(!this.cgService.sortingDeatils[key]){
      return true;
    }else{
      return this.cgService.sortingDeatils[key] == true ? false : true;
    }
  }

  getMaxTableView(){
    if(this.cgService.gridHeaders && Object.keys(this.cgService.gridHeaders).length > 9){
      return true;
    }
    return false;
  }

  getKeyBasedImageSrc(key,type){
    switch (key) {
      case 'recording':
        return '../../../assets/images/recordings.png';
      case 'download' :
        return '../../../assets/eagle-live/mdpi/download-compose.png';
      case 'copy' :
        return '../../../assets/images/xxhdpi/Duplicate.png';  
      default:
        break;
    }
  }

  


  getTimeFormat(date){
    var inputDateString = date;
    var inputDate = new Date(inputDateString);

    var day = inputDate.getDate();
    var month = inputDate.toLocaleString('default', { month: 'short' });
    var year = inputDate.getFullYear();
    var hours = inputDate.getHours();
    var minutes = inputDate.getMinutes();
    var seconds = inputDate.getSeconds();
    var outputDateString = `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
    return outputDateString;


  }

  

 
}



